export default __webpack_public_path__ + "symfony.73b9b389.png";